const APPWRITE_METADATA_KEYS = new Set([
    '$collectionId',
    '$tableId',
    '$permissions',
    '$sequence',
    '$createdAt',
    '$updatedAt',
    '$databaseId',
]);
/**
 * Removes Appwrite metadata fields and converts undefined values to null
 * before saving to Appwrite. Returns a new object without mutating the input.
 *
 * Appwrite returns metadata fields ($collectionId, $createdAt, etc.) when reading,
 * but throws errors if you include them when writing. Undefined values must also
 * be converted to null for Appwrite to clear column values.
 */
function patchAppwritePayload(obj) {
    const result = {};
    for (const key of Object.keys(obj)) {
        if (APPWRITE_METADATA_KEYS.has(key)) {
            continue;
        }
        const value = obj[key];
        if (value === undefined) {
            result[key] = null;
        }
        else if (value === null) {
            result[key] = null;
        }
        else if (typeof value === 'object' && !Array.isArray(value)) {
            result[key] = patchAppwritePayload(value);
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
const RESPONSE_METADATA_KEYS = [
    'collectionId',
    'tableId',
    'databaseId',
    'permissions',
    'sequence',
];
/**
 * Removes Appwrite metadata fields from response objects.
 * Returns new array of cleaned objects without mutating input.
 */
function patchAppwriteResponseObject(obj) {
    return obj.map((item) => {
        const cleaned = { ...item };
        for (const key of RESPONSE_METADATA_KEYS) {
            delete cleaned[key];
        }
        return cleaned;
    });
}
const awWrapperUtils = {
    patchAppwritePayload,
    patchAppwriteResponseObject,
};
export default awWrapperUtils;
